exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 768px){\n    .modal-dialog {\n        width: 700px;\n        margin: 30px auto;\n    }\n    video {\n      width: 100%;\n      height: auto;\n      min-width: 600px;\n      max-height: 450px;\n      -o-object-fit: fill;\n         object-fit: fill;\n      min-height: 400px;\n    }\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/video-report/video-report.component.css
// module id = ../../../../../src/app/dashboard/video-report/video-report.component.css
// module chunks = main